// A tulip glass carrying the wine's colour, in the same line style as the
// bottle: hairline outline, flat liquid, a thin lighter meniscus. The
// "applied treatment" from GlassOptions.dc.html (clear glass, the liquid
// carries the hue) kept, the gloss dropped. Used for compact rows and cards.
import { memo } from "react";
import { Svg, paint } from "../ui/Graphic";
import type { PaletteKey } from "../ui/palette";

export interface GlassProps {
  /** druif's colour vocabulary (see src/lib/colours.ts); kept as a plain
   * string here too since a candidate list mixes several sources. */
  colour: string;
  /** Rendered width in px; the height follows the 28x40 drawing. */
  width?: number;
}

const WINE_PAINT: Record<string, PaletteKey> = {
  white: "wineWhite",
  rose: "wineRose",
  red: "wineRed",
  sparkling: "wineSparkling",
  fortified: "wineFortified",
};

/** The themed paint for a wine colour; anything outside the vocabulary reads as a neutral grey. */
export function winePaint(colour: string): string {
  return paint(WINE_PAINT[colour] ?? "textFaint");
}

const BOWL = "M8 2h12l-.5 11c-.3 7-2.5 12-5.5 12s-5.2-5-5.5-12L8 2z";

function GlassComponent({ colour, width = 22 }: GlassProps): React.JSX.Element {
  return (
    <Svg viewBox="0 0 28 40" width={width} height={(width * 40) / 28}>
      <path d={BOWL} fill={paint("bottleGlass")} />
      <path d="M9.1 14h9.8c-.4 6-2 10-4.9 10s-4.5-4-4.9-10z" fill={winePaint(colour)} />
      <path d="M9.4 14h9.2" stroke={paint("bottlePaper")} strokeOpacity="0.45" strokeWidth="0.7" />
      <path d={BOWL} fill="none" stroke={paint("ink")} strokeOpacity="0.6" strokeWidth="1" />
      <path
        d="M14 25v11M9 37.5h10"
        stroke={paint("ink")}
        strokeOpacity="0.6"
        strokeWidth="1"
        strokeLinecap="round"
      />
    </Svg>
  );
}

export const Glass = memo(GlassComponent);
